module.exports = __webpack_public_path__ + "img/vertical_7_5_9006.e1fe809d.png";